export default function populateHandles(handles) {
    const filterByHandlePresence = ({ handle }) => handle.length;

    const mapHandleTypes = (handle) => {
        if (handle.handleType) {
            return {
                handle: handle.handle,
                'handle-type': handle.handleType,
            };
        }

        return handle;
    };

    return handles.filter(filterByHandlePresence).map(mapHandleTypes) || [];
}
